import * as walletApi from './walletApi'
import {
  CryptoAddressPayload,
  CurrencyInBlockchainPayload,
  WalletPayload,
  CreateKemCardDTO,
  GetKemCardParams,
  KemCardActionsPayload,
  KemCardDTO,
  VerifyCardIssueStatusDTO,
  CryptoAddressWithdrawDTO,
  CreateCryptoAddressWithdrawPayload,
  DeleteCryptoAddressWithdrawPayload,
  CryptoAddressWithdrawParams,
  CryptoAddressWithdrawList,
  GetCardPinDTO,
  SetCardPinPayload,
  GetInterlaceWidgetTokenParams,
  GetInterlaceWidgetTokenResponse,
} from './walletTypes'

export async function getWallet(): Promise<walletApi.WalletDTO> {
  const result = await walletApi.fetchWallet()
  return result
}

export async function getOrCreateCryptoAddress(payload: CryptoAddressPayload) {
  const result = await walletApi.fetchOrCreateCryptoAddress(payload)
  return result
}

export async function getCurrencyInBlockchain(
  payload: CurrencyInBlockchainPayload,
) {
  const result = await walletApi.fetchCurrencyInBlockchain(payload)
  return result
}

export async function updateWallet(payload: WalletPayload): Promise<any> {
  const result = await walletApi.updateWallet(payload)
  return result
}

// Kem Card services
export async function createKemCard(): Promise<CreateKemCardDTO> {
  const result = await walletApi.createKemCard()
  return result
}

export async function getKemCard(
  params: GetKemCardParams,
): Promise<KemCardDTO> {
  const result = await walletApi.getKemCard(params)
  return result
}

/**
 * Fetch sensitive card details without caching
 * This should only be called when user explicitly wants to view card details
 * Data should not be stored in cache or localStorage
 */
export async function fetchKemCardSensitiveDetails(
  cardId: string,
): Promise<KemCardDTO> {
  const result = await walletApi.getKemCard({ cardId })
  return result
}

export async function blockKemCard(
  payload: KemCardActionsPayload,
): Promise<void> {
  const result = await walletApi.blockKemCard(payload)
  return result
}

export async function unblockKemCard(
  payload: KemCardActionsPayload,
): Promise<void> {
  const result = await walletApi.unblockKemCard(payload)
  return result
}

// Withdraw crypto address services
export async function fetchWithdrawCryptoAddressByNetworkCode(
  params: CryptoAddressWithdrawParams,
): Promise<CryptoAddressWithdrawList> {
  const result = await walletApi.fetchWithdrawCryptoAddressByNetworkCode(params)
  return result
}

export async function createWithdrawCryptoAddress(
  payload: CreateCryptoAddressWithdrawPayload,
): Promise<CryptoAddressWithdrawDTO> {
  const result = await walletApi.createWithdrawCryptoAddress({
    address: payload.address.trim(),
    name: payload.name.trim(),
    network_code: payload.network_code,
    grantToken: payload.grantToken,
  })
  return result
}

export async function deleteWithdrawCryptoAddress(
  payload: DeleteCryptoAddressWithdrawPayload,
): Promise<void> {
  const result = await walletApi.deleteWithdrawCryptoAddress(payload)
  return result
}

export async function getCardPin(cardId: string, sessionId: string): Promise<GetCardPinDTO> {
  const result = await walletApi.getCardPin(cardId, sessionId)
  return result
}

export async function setCardPin(payload: SetCardPinPayload): Promise<void> {
  await walletApi.setCardPin(payload)
}

export async function verifyCardIssueStatus(): Promise<VerifyCardIssueStatusDTO> {
  const result = await walletApi.verifyCardIssueStatus()
  return result
}

export async function deleteKemCard(
  payload: KemCardActionsPayload,
): Promise<void> {
  await walletApi.deleteKemCard(payload)
}

export async function getInterlaceWidgetToken(
  params: GetInterlaceWidgetTokenParams,
): Promise<GetInterlaceWidgetTokenResponse> {
  const result = await walletApi.getInterlaceWidgetToken(params)
  return result
}
